import { createFileRoute, Outlet, useNavigate, useRouterState } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@/lib/server-fn-shim";
import { getMyTrip } from "@/lib/trip.functions";
import { useEffect } from "react";
import { AdminSidebar, AdminMobileHeader } from "@/components/admin/AdminNav";
import { AdminTileHub } from "@/components/admin/AdminTileHub";
import { OrganizerNoteBanner } from "@/components/admin/OrganizerNoteBanner";

export const Route = createFileRoute("/_authenticated/admin")({
  component: AdminGate,
});

function AdminGate() {
  const nav = useNavigate();
  const tripFn = useServerFn(getMyTrip);
  const { data, isLoading } = useQuery({ queryKey: ["my-trip"], queryFn: () => tripFn({}) });
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isHubRoot = pathname === "/admin";

  useEffect(() => {
    if (!isLoading && data && !data.isAdmin) nav({ to: "/trip" });
  }, [isLoading, data, nav]);

  if (isLoading) {
    return (
      <div className="admin-shell min-h-screen grid place-items-center text-sm text-muted-foreground">
        Loading console…
      </div>
    );
  }
  if (!data?.isAdmin) return null;

  return (
    <div className="admin-shell min-h-screen">
      <div className="flex">
        <AdminSidebar />
        <div className="flex-1 min-w-0">
          {/* Mobile: tile hub on /admin, slim back header on sub-pages */}
          {isHubRoot ? <AdminTileHub /> : <AdminMobileHeader />}
          {/* Desktop always renders the outlet; mobile sub-pages render it too.
              On mobile /admin the hub replaces the outlet content. */}
          <div className={isHubRoot ? "hidden md:block" : "pb-nav-safe md:pb-0"}>
            {!isHubRoot && <OrganizerNoteBanner />}
            <Outlet />
          </div>

        </div>
      </div>
    </div>
  );
}
